/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { styled } from 'fierry/react';

import HomeButton from 'solis/react/button/home';
import Title from 'solis/react/element/title';


const Header = styled(Flex)`

  height: 64px;
  align-items: center;

  gap: var(--space-1);
  padding-left: var(--space-3);
  padding-right: var(--space-4);

  background: var(--gray-a2);
`;


export default ({ title, badge: Badge }) =>
(
  <Header asChild>
    <header>

      <HomeButton />
      <Title> {title} </Title>

      {Badge && <Flex align = 'center' ml = 'auto'><Badge /></Flex>}

    </header>
  </Header>
);
